// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--KrOEb {\n  flex-shrink: 0;\n  width: 22px;\n  min-width: 22px;\n  max-width: 22px;\n  height: 22px;\n}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Customer/Nav/index.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd","sourcesContent":[".icon {\n  flex-shrink: 0;\n  width: 22px;\n  min-width: 22px;\n  max-width: 22px;\n  height: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--KrOEb"
};
export default ___CSS_LOADER_EXPORT___;
